import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useTimerEntries = (
    { taskId, customAttributeId }: { taskId: number; customAttributeId: number },
    { enabled = true }: { enabled?: boolean } = {}
) => {
    const trpc = useTRPC();
    return useQuery(trpc.timer.list.queryOptions({ taskId, customAttributeId }, { enabled }));
};

/**
 * The caller's running timer, if any. Refetched only on invalidation — a running timer
 * ticks client-side off `startedAt`, so there is nothing to poll for.
 */
export const useActiveTimer = () => {
    const trpc = useTRPC();
    return useQuery(trpc.timer.active.queryOptions(undefined, { staleTime: 30_000 }));
};
